import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Row,
  Col,
} from "reactstrap";
import CustomCheckbox from "./CustomCheckbox";
import strings from "../../../core/translate";

class SelectModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedItems: props.selectedItems
        ? props.selectedItems.map((item) => item.value)
        : [],
      selectAllChecked: props.selectedItems?.length === props.itemsList?.length,
    };
  }

  toggleItem = (itemValue) => {
    this.setState((prevState) => {
      const selectedItems = prevState.selectedItems.includes(itemValue)
        ? prevState.selectedItems.filter((s) => s !== itemValue)
        : [...prevState.selectedItems, itemValue];

      return {
        selectedItems,
        selectAllChecked: selectedItems.length === this.props.itemsList.length,
      };
    });
  };

  toggleSelectAll = () => {
    this.setState((prevState) => {
      const newSelectedItems = prevState.selectAllChecked
        ? [] // Deselect all
        : this.props.itemsList.map((item) => item.value);

      return {
        selectedItems: newSelectedItems,
        selectAllChecked: !prevState.selectAllChecked,
      };
    });
  };

  handleSave = () => {
    const selectedItemObjects = this.state.selectedItems.map((value) => {
      return this.props.itemsList.find((item) => item.value === value);
    });

    this.props.onSave(selectedItemObjects);
    this.props.toggle();
  };

  render() {
    const { isOpen, toggle, itemsList, title } = this.props;
    const { selectedItems, selectAllChecked } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Row>
            <Col md="12">
              <FormGroup check className="d-flex align-items-center mb-2">
                <CustomCheckbox
                  label={strings.selectall}
                  isChecked={selectAllChecked}
                  onChange={this.toggleSelectAll}
                />
              </FormGroup>
            </Col>

            {itemsList.map((item) => (
              <Col md="6" key={item.value}>
                <FormGroup check className="d-flex align-items-center mb-2">
                  <CustomCheckbox
                    label={item.label}
                    isChecked={selectedItems.includes(item.value)}
                    onChange={() => this.toggleItem(item.value)}
                  />
                </FormGroup>
              </Col>
            ))}
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button color="primary" onClick={this.handleSave}>
            {strings.save}
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            {strings.cancel}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default SelectModal;
